import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('rashii_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('rashii_refresh_token');
        if (!refreshToken) throw new Error('No refresh token');

        const response = await axios.post(`${BACKEND_URL}/api/auth/refresh`, {
          refresh_token: refreshToken
        });

        const { access_token, refresh_token: newRefresh } = response.data;
        localStorage.setItem('rashii_access_token', access_token);
        localStorage.setItem('rashii_refresh_token', newRefresh);

        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        return api(originalRequest);
      } catch {
        localStorage.removeItem('rashii_access_token');
        localStorage.removeItem('rashii_refresh_token');
        localStorage.removeItem('rashii_user');
        window.location.href = '/login';
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
